<template>
  <a-modal
    title="付款方式"
    :width="680"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok', param) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="预付款金额" v-if="this.model['type'] < 6">
              <a-input-number style="width: 100%" allow-clear v-decorator="['pre_payment', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
            <a-form-item label="预付款支付期限" v-if="this.model['type'] < 6">
              <a-date-picker
                v-decorator="['pre_payment_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                show-time
                format="YYYY-MM-DD"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
            <a-form-item label="尾款金额" v-if="this.model['type'] >= 6">
              <a-input-number style="width: 100%" allow-clear v-decorator="['balance_payment', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
            <a-form-item label="尾款支付期限" v-if="this.model['type'] >= 6">
              <a-select
                v-decorator="[
                  'trade_balance_payment_date_method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                @change="tradeBalancePaymentTimeChange"
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_balance_payment_date_method">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="确定尾款日期" v-if="this.model['type'] >= 6 && tradeBalancePaymentTimeMethod === 1">
              <a-date-picker
                v-decorator="['balance_payment_date', {rules: [{required: tradeBalancePaymentTimeMethod === 1, message: '必填项，请填写信息'}]}]"
                show-time
                format="YYYY-MM-DD"
                placeholder="锁价期限"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
            <a-form-item label="承兑日后" v-if="this.model['type'] >= 6 && tradeBalancePaymentTimeMethod === 2">
              <a-input-number style="width: 80%" allow-clear v-decorator="['trade_balance_payment_days', {initialValue: 0, rules: [{required: tradeBalancePaymentTimeMethod === 2, message: '必填项，请填写信息'}]}]"/> （天）
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'

// 表单字段
const fields = ['is_archived']
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      tradeBalancePaymentTimeMethod: 0,
      param: {},
      form: this.$form.createForm(this)
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    tradeBalancePaymentTimeChange (v) {
      console.log('tradeBalancePaymentTimeChange', v)
      if (v !== undefined) {
        this.tradeBalancePaymentTimeMethod = Number(v)
      } else {
        this.tradeBalancePaymentTimeMethod = 0
      }
    },
    time (dates, dateStrings) {
      console.log(dateStrings, '时间')
      this.param.start_date = dateStrings[0]
      this.param.end_date = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    }
  }
}
</script>
